import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoguhgaecab() {



    const cardData = {

keyword: "Pune to Guhagar Cabs",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Guhagar Cabs for families, couples, and coastal travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth and scenic journey from Pune to the Konkan coast. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a peaceful and enjoyable travel experience to the serene beaches and temple town of Guhagar.",

topPlaces: [
    {
        title: "Guhagar Beach",
        description:
            "Guhagar Beach is a clean and peaceful stretch of the Konkan coastline known for its soft sand, calm waves, and less crowded environment. It is ideal for relaxation, long walks, and enjoying sunrise and sunset views. The beach is surrounded by coconut trees, creating a perfect natural escape for families and weekend travelers from Pune."
    },
    {
        title: "Vyadeshwar Temple",
        description:
            "Vyadeshwar Temple is the most important religious site in Guhagar, dedicated to Lord Shiva. It is an ancient and highly respected temple known for its spiritual atmosphere, traditional architecture, and daily rituals that attract devotees throughout the year."
    },
    {
        title: "Velneshwar Beach & Temple",
        description:
            "Velneshwar Beach is a serene coastal destination near Guhagar known for its clean shoreline and peaceful surroundings. The nearby Velneshwar Shiva Temple adds spiritual significance, making it a perfect blend of devotion and natural beauty."
    },
    {
        title: "Gopalgad Fort (Anjanwel Fort)",
        description:
            "Gopalgad Fort is a historic hill fort overlooking the Arabian Sea near Guhagar. It offers panoramic coastal views and reflects Maratha-era architecture, making it an interesting stop for history lovers and explorers."
    },
    {
        title: "Hedvi Beach",
        description:
            "Hedvi Beach is a beautiful and less commercialized beach near Guhagar known for its rocky shoreline and scenic views. It is perfect for photography, peaceful walks, and enjoying untouched Konkan beauty."
    },
    {
        title: "Bamanghal",
        description:
            "Bamanghal is a natural rock formation near Guhagar where seawater gushes through narrow rock gaps, creating a unique natural spectacle. It is a popular attraction for tourists and nature enthusiasts."
    },
    {
        title: "Shringarpur Village",
        description:
            "Shringarpur is a small traditional Konkan village near Guhagar known for its cultural heritage, temples, and peaceful rural lifestyle. It offers an authentic experience of coastal Maharashtra living."
    },
    {
        title: "Anjanwel Lighthouse",
        description:
            "Anjanwel Lighthouse is located near Guhagar coast and offers panoramic views of the Arabian Sea and surrounding coastline. It is a great photography and sightseeing point during coastal trips."
    },
    {
        title: "Chiplun River Region",
        description:
            "Chiplun lies on the route to Guhagar and is known for its lush greenery, Vashishti River, and scenic landscapes. It serves as a refreshing stopover during the Pune to Konkan journey."
    },
    {
        title: "Konkan Coastal Highway Route",
        description:
            "The Pune to Guhagar route via the Konkan highway offers a scenic journey through the Western Ghats, dense greenery, river bridges, and coastal stretches. The drive itself is a major highlight, making cab travel highly enjoyable and memorable."
    }
],



services: [
  {
    name: "Pune to Guhagar Cab",
    description: "Rising Cab Service offers reliable Pune to Guhagar Cab service for a safe, scenic, and comfortable Konkan coastal journey to Guhagar beach destination. Ideal for families, couples, and groups, our service includes well-maintained AC vehicles, experienced long-distance drivers, doorstep pickup from Pune, flexible travel timing, and 24x7 booking support. Enjoy a smooth highway drive through lush green Konkan routes, coastal scenery, and peaceful travel experience with complete comfort, transparent pricing, and stress-free journey planning. We ensure every trip is well-coordinated with professional service, timely pickup, and safe driving throughout the route."
  },
  {
    name: "Pune to Guhagar Taxi",
    description: "Book Pune to Guhagar Taxi with Rising Cab Service for a comfortable and hassle-free journey to the serene Guhagar beach town. We provide clean sanitized vehicles, professional chauffeurs, and safe driving across highways and Konkan coastal roads. Perfect for weekend trips, family vacations, beach holidays, and temple visits, our taxi service ensures flexible pickup and drop options, smooth travel experience, and reliable long-distance support. Enjoy scenic routes, comfortable seating, and stress-free travel with complete customer assistance."
  },
  {
    name: "Cab from Pune to Guhagar",
    description: "Hire Cab from Pune to Guhagar for convenient door-to-door travel with complete flexibility and comfort. Choose from sedans, SUVs, and Innova Crysta depending on your group size and travel needs. Our experienced drivers ensure safe coastal travel with smooth rides, scenic stops, and full travel assistance. The journey is planned for comfort, safety, and relaxation so you can enjoy Konkan beauty without any travel stress."
  },
  {
    name: "Taxi from Pune to Guhagar",
    description: "Taxi from Pune to Guhagar service ensures punctual pickup, professional driving, and a safe long-distance journey to the Konkan beach destination. Ideal for family vacations and weekend getaways, our taxis offer AC comfort, affordable pricing, and reliable service. We focus on customer satisfaction with clean vehicles, trained drivers, and smooth travel coordination."
  },
  {
    name: "Pune to Guhagar Cab Service",
    description: "Our Pune to Guhagar Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We focus on safety, comfort, and affordability with trained drivers, well-maintained vehicles, and 24x7 booking assistance. Every trip is designed to offer a smooth and enjoyable Konkan travel experience with reliable service and professional support."
  },
  {
    name: "Pune to Guhagar Taxi Fare",
    description: "Get transparent Pune to Guhagar Taxi Fare with clear and affordable pricing based on vehicle type and travel plan. We offer budget-friendly and premium options for sedans, SUVs, and Innova Crysta with no hidden charges. Pricing is designed to ensure value for money while maintaining high comfort and safety standards for long coastal journeys."
  },
  {
    name: "Pune to Guhagar One Way Cab",
    description: "Book Pune to Guhagar One Way Cab for economical drop-only travel to the scenic Konkan coast. Ideal for solo travelers and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates without return charges. It is perfect for those planning flexible travel schedules."
  },
  {
    name: "Pune to Guhagar Round Trip Taxi",
    description: "Pune to Guhagar Round Trip Taxi service is perfect for beach vacations and weekend trips. It includes flexible return scheduling, waiting time, comfortable vehicles, and experienced drivers for a complete round-trip travel experience. Enjoy hassle-free travel with full trip management."
  },
  {
    name: "Pune to Guhagar Cab Booking",
    description: "Easy Pune to Guhagar Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support for smooth booking experience and reliable travel planning."
  },
  {
    name: "Cheap Pune to Guhagar Cab",
    description: "Affordable Cheap Pune to Guhagar Cab service for budget travelers who want economical yet safe coastal travel. We provide low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety, making your Konkan trip budget-friendly and enjoyable."
  },
  {
    name: "Best Pune to Guhagar Taxi",
    description: "Choose Best Pune to Guhagar Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving through scenic Konkan routes. We ensure quality service, punctuality, and complete customer satisfaction."
  },
  {
    name: "Sedan Pune to Guhagar Cab",
    description: "Sedan Pune to Guhagar Cab service is ideal for solo travelers, couples, and small families seeking budget-friendly and comfortable long-distance travel. Enjoy smooth rides and fuel-efficient vehicles with professional drivers."
  },
  {
    name: "SUV Pune to Guhagar Taxi",
    description: "Book SUV Pune to Guhagar Taxi for group travel requiring extra space and comfort. Our SUVs are perfect for Konkan routes, offering smooth rides, strong performance, and spacious interiors for long journeys."
  },
  {
    name: "Innova Pune to Guhagar Cab",
    description: "Premium Innova Pune to Guhagar Cab service for families and groups seeking luxury, comfort, and spacious seating for long coastal journeys. Enjoy smooth suspension and experienced chauffeurs."
  },
  {
    name: "Konkan Beach Cab Pune Guhagar",
    description: "Konkan Beach Cab Pune Guhagar service is specially designed for exploring Guhagar beach and nearby Konkan destinations with scenic routes and comfortable travel options."
  },
  {
    name: "Guhagar Cab from Pune",
    description: "Guhagar Cab from Pune service offers direct door-to-door travel to the beach destination with safe driving, flexible travel plans, and reliable service."
  },
  {
    name: "Pune to Guhagar Beach Cab",
    description: "Pune to Guhagar Beach Cab service ensures a smooth and scenic coastal journey with professional drivers and comfortable vehicles for a relaxing beach trip experience."
  },
  {
    name: "Pune to Guhagar Tourist Cab Service",
    description: "Pune to Guhagar Tourist Cab Service provides complete travel solutions for tourists exploring Konkan beaches, temples, and nearby attractions with reliable transportation."
  },
  {
    name: "Pune to Guhagar Innova Taxi",
    description: "Pune to Guhagar Innova Taxi service offers premium comfort for families and groups with spacious seating and smooth long-distance travel experience."
  },
  {
    name: "Pune to Guhagar Travel Package",
    description: "Pune to Guhagar Travel Package includes pickup, beach visits, sightseeing, and return journey for a complete hassle-free Konkan vacation experience."
  },
  {
    name: "Pune to Guhagar Holiday Package",
    description: "Pune to Guhagar Holiday Package offers complete travel solutions for weekend and holiday trips with sightseeing and comfortable cab service included."
  },
  {
    name: "Pune to Guhagar Konkan Tour Cab",
    description: "Pune to Guhagar Konkan Tour Cab provides curated travel experiences covering scenic coastal routes, beaches, and Konkan attractions."
  },
  {
    name: "Pune to Guhagar Outstation Cab",
    description: "Pune to Guhagar Outstation Cab service ensures safe and reliable long-distance travel with professional drivers and well-maintained vehicles."
  },
  {
    name: "Guhagar Cab from Pune Online Booking",
    description: "Guhagar Cab from Pune Online Booking system allows instant reservations with transparent pricing, multiple vehicle options, and 24x7 support."
  }
],

tableData: [
  ["Pune to Guhagar Cab", "Pune to Guhagar Taxi"],
  ["Cab from Pune to Guhagar", "Taxi from Pune to Guhagar"],
  ["Pune to Guhagar Cab Service", "Pune to Guhagar Taxi Fare"],
  ["Pune to Guhagar One Way Cab", "Pune to Guhagar Round Trip Taxi"],
  ["Pune to Guhagar Cab Booking", "Cheap Pune to Guhagar Cab"],
  ["Best Pune to Guhagar Taxi", "Sedan Pune to Guhagar Cab"],
  ["SUV Pune to Guhagar Taxi", "Innova Pune to Guhagar Cab"],
  ["Konkan Beach Cab Pune Guhagar", "Guhagar Cab from Pune"],
  ["Pune to Guhagar Beach Cab", "Pune to Guhagar Travel Package"],
  ["Pune to Guhagar Holiday Package", "Pune to Guhagar Konkan Tour Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Guhagar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Guhagar cab transportation for families, tourists, beach lovers, couples, and Konkan holiday travelers."
    },
    {
        WhyChooseheading: "Perfect Destination for Coastal Tourism",
        WhyChoosedescription: "Guhagar is known for its clean beaches, peaceful environment, coconut plantations, ancient temples, and scenic Konkan coastline."
    },
    {
        WhyChooseheading: "Ideal for Family Holidays and Weekend Getaways",
        WhyChoosedescription: "Whether planning a beach vacation, family tour, honeymoon trip, temple visit, or Konkan sightseeing package, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Travel Need",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your group size and travel preferences."
    },
    {
        WhyChooseheading: "Explore Popular Attractions Around Guhagar",
        WhyChoosedescription: "Travel conveniently to Guhagar Beach, Vyadeshwar Temple, Hedvi Ganpati Temple, Velneshwar Beach, Anjanvel Lighthouse, and nearby Konkan attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        WhyChooseheading: "Safe Travel Through Scenic Konkan Routes",
        WhyChoosedescription: "Our experienced drivers ensure smooth travel through beautiful coastal roads and ghat sections while prioritizing passenger safety and comfort."
    },
    {
        WhyChooseheading: "Perfect for Couples, Families, and Groups",
        WhyChoosedescription: "Rising Cab Service caters to honeymoon travelers, family vacations, beach holidays, pilgrimage tours, and group sightseeing trips."
    }
]
};

const faqData = [
    {
        question: "Why is Guhagar a popular tourist destination from Pune?",
        answer: "Guhagar is famous for its serene beach, Vyadeshwar Temple, coconut groves, peaceful atmosphere, and untouched Konkan beauty."
    },
    {
        question: "Can I book a one-way cab from Pune to Guhagar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Konkan travel packages."
    },
    {
        question: "Which attractions can be visited during a Guhagar trip?",
        answer: "Popular attractions include Guhagar Beach, Vyadeshwar Temple, Hedvi Ganpati Temple, Velneshwar Beach, Anjanvel Lighthouse, and nearby coastal villages."
    },
    {
        question: "Which vehicle is suitable for a family trip to Guhagar?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide spacious seating and comfortable long-distance travel."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and Konkan sightseeing tours."
    },
    {
        question: "Can Guhagar and Dapoli be covered in one trip?",
        answer: "Yes, customized itineraries can include Guhagar, Dapoli, Velneshwar, Hedvi, Ganpatipule, and other Konkan destinations."
    },
    {
        question: "Are weekend holiday packages available for Guhagar?",
        answer: "Yes, customers can choose weekend tours, overnight stays, and multi-day Konkan vacation packages."
    },
    {
        question: "Can temple visits and beach sightseeing be combined?",
        answer: "Yes, travel plans can include both religious attractions and coastal sightseeing according to customer preferences."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Guhagar Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nilesh Bapat",
        feedback:
            "Our family vacation to Guhagar was incredibly relaxing. The cab was comfortable, the coastal route was beautiful, and the entire journey was managed professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Apte",
        feedback:
            "We explored Guhagar Beach, Hedvi, and Velneshwar during our Konkan trip. The travel arrangements were excellent, making the holiday enjoyable and completely stress-free.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Guhagar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-guhagar-cab.jpg",
"description": "Book Pune to Guhagar Cab Service with Rising Cab Service for safe and comfortable Konkan coastal travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach and family trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-guhagar-cab"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Guhagar Cab Service | Konkan Beach Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Guhagar Cab Service for safe and comfortable Konkan coastal travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach holidays."
/>

<meta
 name="keywords"
 content="pune to guhagar cab, pune to guhagar taxi, cab from pune to guhagar, taxi from pune to guhagar, pune to guhagar cab service, pune to guhagar taxi fare, pune to guhagar one way cab, pune to guhagar round trip taxi, pune to guhagar cab booking, cheap pune to guhagar cab, best pune to guhagar taxi, sedan pune to guhagar cab, suv pune to guhagar taxi, konkan guhagar cab pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoguhgaecab;